import type { FunctionComponent } from 'react';

export const AddUserIcon: FunctionComponent = () => (
    // biome-ignore lint/a11y/noSvgWithoutTitle: suppressed due to migration
    <svg fill="none" height="16" viewBox="0 0 16 16" width="16" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M7.9016 8.83288C5.68951 8.87126 4.01378 10.2026 3.32166 12.074C3.04913 12.8108 3.6789 13.4987 4.46457 13.4987H8.33335M7.9016 8.83288C7.93429 8.83232 7.96709 8.83203 8.00001 8.83203C8.23474 8.83203 8.46358 8.84651 8.68602 8.87458M7.9016 8.83288C7.4682 8.8404 7.05563 8.89756 6.66674 8.9987M8.68602 8.87458C8.90846 8.90265 9.1245 8.94432 9.33361 8.9987M8.68602 8.87458C9.15397 8.93363 9.5936 9.05285 10 9.22404M12.1667 10.1654V12.1654M12.1667 12.1654V14.1654M12.1667 12.1654H10.1667M12.1667 12.1654H14.1667M10.5 4.33203C10.5 5.71274 9.38073 6.83203 8.00001 6.83203C6.6193 6.83203 5.50001 5.71274 5.50001 4.33203C5.50001 2.95132 6.6193 1.83203 8.00001 1.83203C9.38073 1.83203 10.5 2.95132 10.5 4.33203Z"
            stroke="#6E6E6C"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.5"
        />
    </svg>
);
